import { useEffect } from "react";
import { SITE_URL, localBusinessSchema } from "@/lib/seo";

// Dependency-free head manager (react-helmet-async is not React 19 compatible).
// Sets title/meta/canonical/OG/Twitter + JSON-LD on mount & on prop change.
// The build-time prerenderer captures the resulting <head> into static HTML.
function upsertMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
  el.setAttribute("data-seo", "true");
}

export default function Seo({ title, description, path = "/", image, schema = [] }) {
  const schemaKey = JSON.stringify(schema);

  useEffect(() => {
    const url = `${SITE_URL}${path}`;
    const ogImage = image || `${SITE_URL}/assets/hero-photos/trailer-wrap-hero.png`;

    document.title = title;
    upsertMeta("name", "description", description);

    let canon = document.head.querySelector('link[rel="canonical"]');
    if (!canon) {
      canon = document.createElement("link");
      canon.setAttribute("rel", "canonical");
      document.head.appendChild(canon);
    }
    canon.setAttribute("href", url);
    canon.setAttribute("data-seo", "true");

    upsertMeta("property", "og:type", "website");
    upsertMeta("property", "og:site_name", "RGV Gaming");
    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:url", url);
    upsertMeta("property", "og:image", ogImage);
    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", title);
    upsertMeta("name", "twitter:description", description);
    upsertMeta("name", "twitter:image", ogImage);

    // Replace JSON-LD blocks for this page
    document.head.querySelectorAll('script[data-seo-ld="true"]').forEach((s) => s.remove());
    [localBusinessSchema(), ...schema].forEach((obj) => {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.setAttribute("data-seo-ld", "true");
      s.textContent = JSON.stringify(obj);
      document.head.appendChild(s);
    });
  }, [title, description, path, image, schemaKey]);

  return null;
}
